module.exports = __webpack_public_path__ + "static/media/notif-not-support.4d69df70.png";